import { useEffect, useState } from "react";
import useNotification from "hooks/useNotification";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useDispatch, useSelector } from "react-redux";
import { AppSettingsAlt } from "@mui/icons-material";
import CustomButton from "components/CustomButton";
import { setShowMassage } from "store/sysSlice";
import { getFromLocalStorage } from "config/functions";
import CustomDialog from "components/CustomDialog";
import { Checkbox, Divider, FormControlLabel, Stack, Typography } from "@mui/material";

const Permission = ({ open, setOpen }) => {
    const dispatch = useDispatch()
    const { bt } = useBizTypeTranslation();
    const user = useSelector((state) => state.userSettings?.user);
    const { checkIsDefaultPermission, requestNotification } = useNotification()
    const [loading, setLoading] = useState(false)
    const [dontAskAgain, setDontAskAgain] = useState(false)

    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    useEffect(() => {
        const PermissionDontAskAgain = getFromLocalStorage("PermissionDontAskAgain");
        if (checkIsDefaultPermission() && !PermissionDontAskAgain && user?.id)
            setOpen(true)
    }, [user]);

    const onRequestNotification = async () => {
        setLoading(true)
        if (user?.id && !isIOS) {
            const res = await requestNotification(user?.id)
            setLoading(false)
            if (res === 1) {
                setOpen(false)
                dispatch(setShowMassage({ massage: "PERMISSION_SUCCESS", type: "success" }));
            }
            else if (res) {
                setOpen(false)
                dispatch(setShowMassage({ massage: "PERMISSION_ERROR", type: "error" }));
            }
        }
    }

    const onClose = () => {
        if (dontAskAgain)
            localStorage.setItem("PermissionDontAskAgain", true);

        setOpen(false)
    };

    return (
        <CustomDialog
            open={open}
            onClose={onClose}
            title='PERMISSION'
        >
            <Stack px={2} pb={2} spacing={2} alignItems='center'>

                <AppSettingsAlt sx={{ fontSize: 100, color: "primary.main" }} />
                <Typography textAlign='center'>{bt('PERMISSION_MSG1')}</Typography>
                <Divider sx={{ width: '100%' }} />

                <Stack width='100%' direction='row' alignItems='center' justifyContent='space-between'>
                    <Typography>{bt('REQUEST_NOTIFICATION')}</Typography>
                    <CustomButton
                        fontSize={15}
                        title='AUTHORIZE_ACCESS'
                        disabled={loading}
                        onClick={onRequestNotification}
                    />
                </Stack>

                <Divider sx={{ width: '100%' }} />

                <Stack width='100%' direction='row' alignItems='center' justifyContent='space-between'>
                    <FormControlLabel
                        control={<Checkbox
                            checked={dontAskAgain}
                            disabled={loading}
                            onChange={(e) => setDontAskAgain(e.target.checked)}
                        />}
                        label={bt("DONT_ASK_AGAIN")}
                    />
                    <CustomButton
                        variant='outlined'
                        title='CLOSE'
                        disabled={loading}
                        onClick={onClose}
                    />
                </Stack>

            </Stack>
        </CustomDialog>
    );
};
export default Permission;